var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("edit-threshold-modal-component", {
        ref: _vm.REF_CONSTANTS.EDIT_THRESHOLD_MODAL,
        on: { "reload:thresholds": _vm.loadThresholds },
      }),
      _c("pui-loader", { attrs: { promise: _vm.thresholdsPromise } }, [
        _c(
          "div",
          { staticClass: "thresholds-tab" },
          _vm._l(_vm.VALID_SUBPROCESSES, function (subProcess) {
            return _c(
              "pui-collapsible",
              {
                key: subProcess,
                attrs: {
                  headline: _vm.$t(_vm.SUB_PROCESSES[subProcess].label),
                  configurable: true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "collapsibleConfigurationContent",
                      fn: function () {
                        return [
                          _c(
                            "pui-button",
                            {
                              staticClass: "thresholds-tab__collapsible-button",
                              attrs: { icon: "add" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.addThresholdClicked(subProcess)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("thresholdsTab.addThreshold")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _c("thresholds-table", {
                  attrs: {
                    "threshold-items":
                      _vm.getThresholdItemsForSubProcess(subProcess),
                  },
                  on: {
                    "click:edit-threshold": function ($event) {
                      return _vm.editThresholdClicked(subProcess, $event)
                    },
                  },
                }),
              ],
              1
            )
          }),
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }